import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'stroke-dynamic', 'StrokeDynamic', [["path",{"d":"M4 19h6a2 2 0 0 0 2 -2v-10a2 2 0 0 1 2 -2h7","key":"svg-0"}]]);